import {Validation, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";
import {noop} from "../../../common/utils/functions";

export class Optional extends Validation {

    public constructor() {
        super("", WarningLevel.ERROR);
    }

    protected valid(value: unknown): boolean {
        return true;
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value?: T): void {
        noop();
    }
}